import React, { useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';

const Quill = (props) => {
  const { id, value, labelClass, labelStyle, label, onChange, codeblockEnable } = props;

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      [
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        ...(codeblockEnable ? ['code-block'] : []),
      ],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
    ...(codeblockEnable ? ['code-block'] : []),
  ];

  const quillEl = useRef(null);

  const handleContainerClick = (e) => {
    const specifiedElement = document
      .getElementById(`quill${id}`)
      .querySelector('.ql-tooltip.ql-editing');
    const isClickInside = specifiedElement && specifiedElement.contains(e.target);
    if (!isClickInside) {
      quillEl.current.focus();
    }
  };

  return (
    <React.Fragment>
      {label ? (
        <label className={labelClass} htmlFor={id} style={labelStyle}>
          {label}
        </label>
      ) : null}
      <div onClick={handleContainerClick} id={`quill${id}`} data-testid={`quill${id}`}>
        <ReactQuill
          value={value || ''}
          modules={modules}
          formats={formats}
          ref={quillEl}
          onChange={(newValue, delta, source) => {
            if (source === 'user') {
              onChange(newValue);
            }
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default Quill;
